import { AfterContentChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Question } from '../../interfaces/questionInterface';
import { NgIconComponent } from '@ng-icons/core';
import { FeedbackComponent } from '../feedback/feedback.component';
import { QuestionService } from '../../services/question.service';
import { ActionDropdownComponent } from '../action-dropdown/action-dropdown.component';

@Component({
    selector: 'app-question',
    imports: [NgIconComponent, ActionDropdownComponent],
    templateUrl: './question.component.html',
    styleUrl: './question.component.scss'
})
export class QuestionComponent implements AfterContentChecked, OnChanges {
  @Input() question: Question | undefined;
  @Input() flagged: boolean = false;
  @Input() showFlag: boolean = true;
  @Input() index: number = 0;
  @Input() total: number = 0;

  @Input() existingAnswers: string[] = [];
  @Input() disabled: boolean = false;

  @Input() orderSeed?: string;

  @Output() questionFlagged = new EventEmitter<boolean>();
  @Output() answersSelected = new EventEmitter<string[]>();

  public correctCount: number = 0;

  constructor(private cdr: ChangeDetectorRef, private readonly questionService: QuestionService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['question']?.currentValue) {
      if(this.orderSeed){
        changes['question'].currentValue = this.questionService.shuffleAnswerOptions(changes['question']?.currentValue, this.orderSeed)
      }

      // workaround for KNOOT-587 (google translate)
      this.question = undefined;
      this.cdr.detectChanges()
      this.question = changes['question'].currentValue;

      this.correctCount = this.question?.expand.answer_options?.filter((a) => a.correct).length || 0;
    }
  }

  ngAfterContentChecked(): void {
    if (this.existingAnswers.length > 0) {
      this.setExistingAnswers();
    }
  }

  setExistingAnswers() {
    this.existingAnswers.forEach((answer) => {
      const answerOption = document.querySelector(`input[value="${answer}"]`);
      if (answerOption) {
        answerOption.setAttribute('checked', 'checked');
      }
    });
  }

  toggleFlagged() {
    this.flagged = !this.flagged;
    this.questionFlagged.emit(this.flagged);
  }

  onSelectionChange(): void {
    const selectedValues = this.getSelectedValues();
    this.answersSelected.emit(selectedValues);
  }

  private getSelectedValues(): string[] {
    const selectedOptions = document.querySelectorAll('input[name="answer_option"]:checked, input[name="singleSelectAnswer"]:checked');
    const selectedValues = Array.from(selectedOptions).map((option: any) => option.value);
    return selectedValues;
  }
}
